/* eslint quotes: 0 */
export default {
  "container": {
    "containerSearchInProgress": "❌ container.containerSearchInProgress",
    "noContainersWithSufficientProductQuantityFound": "❌ container.noContainersWithSufficientProductQuantityFound",
    "searchForProductInContainers": "❌ container.searchForProductInContainers"
  },
  "contractor": {
    "acceptanceDate": "❌ contractor.acceptanceDate",
    "all": "❌ contractor.all",
    "chooseContractor": "❌ contractor.chooseContractor",
    "chooseEndedStatus": "❌ contractor.chooseEndedStatus",
    "chooseSettlementStatus": "❌ contractor.chooseSettlementStatus",
    "contractor": "❌ contractor.contractor",
    "dateOfSampleAndAcceptance": "❌ contractor.dateOfSampleAndAcceptance",
    "listOfContractorsWorksToBeSettled": "❌ contractor.listOfContractorsWorksToBeSettled",
    "makeSettlementErrorText": "❌ contractor.makeSettlementErrorText",
    "noItemsToBeSettled": "❌ contractor.noItemsToBeSettled",
    "onlyEnded": "❌ contractor.onlyEnded",
    "serviceCost": "❌ contractor.serviceCost",
    "toBeSettled": "❌ contractor.toBeSettled",
    "unitPrice": "❌ contractor.unitPrice"
  },
  "contractorsSettlementsImportPopup": {
    "importSuccessDesc": "❌ contractorsSettlementsImportPopup.importSuccessDesc",
    "importSuccessTitle": "❌ contractorsSettlementsImportPopup.importSuccessTitle",
    "importTitle": "❌ contractorsSettlementsImportPopup.importTitle",
    "importXlsx": "❌ contractorsSettlementsImportPopup.importXlsx",
    "xlsxFile": "❌ contractorsSettlementsImportPopup.xlsxFile"
  },
  "customer": {
    "addAddress": "❌ customer.addAddress",
    "addAddressErrorText": "❌ customer.addAddressErrorText",
    "addAddressSuccessText": "❌ customer.addAddressSuccessText",
    "addAddressSuccessTitle": "❌ customer.addAddressSuccessTitle",
    "addContactPerson": "❌ customer.addContactPerson",
    "addContactPersonErrorText": "❌ customer.addContactPersonErrorText",
    "addContactPersonSuccessText": "❌ customer.addContactPersonSuccessText",
    "addContactPersonSuccessTitle": "❌ customer.addContactPersonSuccessTitle",
    "addCustomer": "❌ customer.addCustomer",
    "addCustomerErrorText": "❌ customer.addCustomerErrorText",
    "addCustomerSuccessText": "❌ customer.addCustomerSuccessText",
    "addCustomerSuccessTitle": "❌ customer.addCustomerSuccessTitle",
    "addErrorText": "❌ customer.addErrorText",
    "addNewCustomer": "❌ customer.addNewCustomer",
    "addSuccessText": "❌ customer.addSuccessText",
    "addSuccessTitle": "❌ customer.addSuccessTitle",
    "addingContactPersonAvailableAfterCustomerSave": "❌ customer.addingContactPersonAvailableAfterCustomerSave",
    "addingNewCustomer": "❌ customer.addingNewCustomer",
    "addingShippingAddressAvailableAfterCustomerSave": "❌ customer.addingShippingAddressAvailableAfterCustomerSave",
    "addingTransaltionsAvailableAfterCustomerSave": "❌ customer.addingTransaltionsAvailableAfterCustomerSave",
    "building": "❌ customer.building",
    "buildingNumber": "❌ customer.buildingNumber",
    "changePassword": "❌ customer.changePassword",
    "changeYourPassword": "❌ customer.changeYourPassword",
    "city": "❌ customer.city",
    "company": "❌ customer.company",
    "companyName": "❌ customer.companyName",
    "contact": {
      "contact": "❌ customer.contact.contact"
    },
    "contactAddress": "❌ customer.contactAddress",
    "contactPeople": "❌ customer.contactPeople",
    "correspondenceAddressSet": "❌ customer.correspondenceAddressSet",
    "correspondenceAddressSetDesc": "❌ customer.correspondenceAddressSetDesc",
    "correspondenceInfo": "❌ customer.correspondenceInfo",
    "customerCountryQuestionMark": "❌ customer.customerCountryQuestionMark",
    "customerLogo": "❌ customer.customerLogo",
    "customers": "❌ customer.customers",
    "customersList": "❌ customer.customersList",
    "deleteAddressConfirmTitle": "❌ customer.deleteAddressConfirmTitle",
    "deleteAddressErrorText": "❌ customer.deleteAddressErrorText",
    "deleteAddressSuccessText": "❌ customer.deleteAddressSuccessText",
    "deleteAddressSuccessTitle": "❌ customer.deleteAddressSuccessTitle",
    "deleteContactPersonConfirmTitle": "❌ customer.deleteContactPersonConfirmTitle",
    "deleteContactPersonErrorText": "❌ customer.deleteContactPersonErrorText",
    "deleteContactPersonSuccessText": "❌ customer.deleteContactPersonSuccessText",
    "deleteContactPersonSuccessTitle": "❌ customer.deleteContactPersonSuccessTitle",
    "discount": {
      "deliveryDiscount": "❌ customer.discount.deliveryDiscount",
      "productDiscount": "❌ customer.discount.productDiscount",
      "servicesDiscount": "❌ customer.discount.servicesDiscount"
    },
    "edit": "❌ customer.edit",
    "editAddress": "❌ customer.editAddress",
    "editAddressErrorText": "❌ customer.editAddressErrorText",
    "editAddressSuccessText": "❌ customer.editAddressSuccessText",
    "editAddressSuccessTitle": "❌ customer.editAddressSuccessTitle",
    "editClientErrorText": "❌ customer.editClientErrorText",
    "editClientSuccessText": "❌ customer.editClientSuccessText",
    "editClientSuccessTitle": "❌ customer.editClientSuccessTitle",
    "editContactPerson": "❌ customer.editContactPerson",
    "editContactPersonErrorText": "❌ customer.editContactPersonErrorText",
    "editContactPersonSuccessText": "❌ customer.editContactPersonSuccessText",
    "editContactPersonSuccessTitle": "❌ customer.editContactPersonSuccessTitle",
    "editPasswordErrorText": "❌ customer.editPasswordErrorText",
    "editPasswordSuccessText": "❌ customer.editPasswordSuccessText",
    "editPasswordSuccessTitle": "❌ customer.editPasswordSuccessTitle",
    "enterCustomerData": "❌ customer.enterCustomerData",
    "fountAddresses": "❌ customer.fountAddresses",
    "getDataFromGUS": "❌ customer.getDataFromGUS",
    "getDataFromVIES": "❌ customer.getDataFromVIES",
    "houseNumber": "❌ customer.houseNumber",
    "invoiceAddressSet": "❌ customer.invoiceAddressSet",
    "invoiceAddressSetDesc": "❌ customer.invoiceAddressSetDesc",
    "invoiceAndCorrespondenceAddressSet": "❌ customer.invoiceAndCorrespondenceAddressSet",
    "invoiceAndCorrespondenceAddressSetDesc": "❌ customer.invoiceAndCorrespondenceAddressSetDesc",
    "invoiceInfo": "❌ customer.invoiceInfo",
    "invoiceName": "❌ customer.invoiceName",
    "isOrdersInRpogress": "❌ customer.isOrdersInRpogress",
    "maxAddressSearchResults": "❌ customer.maxAddressSearchResults",
    "newsletterAgreement": "❌ customer.newsletterAgreement",
    "noAddressesToDisplay": "❌ customer.noAddressesToDisplay",
    "noContactPeopleToDisplay": "❌ customer.noContactPeopleToDisplay",
    "noCustomerMarchingPhraseFound": "❌ customer.noCustomerMarchingPhraseFound",
    "noCustomersToDisplay": "❌ customer.noCustomersToDisplay",
    "noTranslationsForThisClient": "❌ customer.noTranslationsForThisClient",
    "notFoundInVIESGUSText": "❌ customer.notFoundInVIESGUSText",
    "notFoundInVIESGUSTitle": "❌ customer.notFoundInVIESGUSTitle",
    "offersInProgress": "❌ customer.offersInProgress",
    "ordersAndOffers": "❌ customer.ordersAndOffers",
    "ordersInProgress": "❌ customer.ordersInProgress",
    "passowrdChange": "❌ customer.passowrdChange",
    "person": "❌ customer.person",
    "phoneShortCap": "❌ customer.phoneShortCap",
    "profile": "❌ customer.profile",
    "removeCustomerConfirmTitle": "❌ customer.removeCustomerConfirmTitle",
    "removeCustomerErrorText": "❌ customer.removeCustomerErrorText",
    "removeCustomerSuccessText": "❌ customer.removeCustomerSuccessText",
    "removeCustomerSuccessTitle": "❌ customer.removeCustomerSuccessTitle",
    "removeLogo": "❌ customer.removeLogo",
    "searchAddressesByCompanyNameAddressOrContactInfo": "❌ customer.searchAddressesByCompanyNameAddressOrContactInfo",
    "selectCustomer": "❌ customer.selectCustomer",
    "shippingInfo": "❌ customer.shippingInfo",
    "showCustomerDrafts": "❌ customer.showCustomerDrafts",
    "showCustomerOrders": "❌ customer.showCustomerOrders",
    "statistics": "❌ customer.statistics",
    "stockReportsNotifications": "❌ customer.stockReportsNotifications",
    "street": "❌ customer.street",
    "telephone": "❌ customer.telephone",
    "termsOfSale": "❌ customer.termsOfSale",
    "unsettledInvoices": "❌ customer.unsettledInvoices",
    "vatIDNumber": "❌ customer.vatIDNumber",
    "verificationIntegrationDisabledDesc": "❌ customer.verificationIntegrationDisabledDesc",
    "verificationIntegrationDisabledTitle": "❌ customer.verificationIntegrationDisabledTitle",
    "withOrdersInProgress": "❌ customer.withOrdersInProgress",
    "withoutOrdersInProgress": "❌ customer.withoutOrdersInProgress",
    "youMustSelectCountryPrefix": "❌ customer.youMustSelectCountryPrefix",
    "youMustSelectCountryPrefixDesc": "❌ customer.youMustSelectCountryPrefixDesc",
    "yourAccount": "❌ customer.yourAccount",
    "zipCode": "❌ customer.zipCode"
  },
  "customerOrdersPopup": {
    "offers": "❌ customerOrdersPopup.offers",
    "orders": "❌ customerOrdersPopup.orders"
  },
  "dashboard": {
    "customersPopup": {
      "customerEmail": "❌ dashboard.customersPopup.customerEmail",
      "customerName": "❌ dashboard.customersPopup.customerName",
      "customerPhone": "❌ dashboard.customersPopup.customerPhone",
      "title": "❌ dashboard.customersPopup.title"
    }
  },
  "errorPage": {
    "errorCode": "❌ errorPage.errorCode",
    "pageDoesNotExist": "❌ errorPage.pageDoesNotExist",
    "tryAgainLaterOrContactAdministrator": "❌ errorPage.tryAgainLaterOrContactAdministrator"
  },
  "inquiries": {
    "addComments": "❌ inquiries.addComments",
    "addFirstProductInstructionInfo": "❌ inquiries.addFirstProductInstructionInfo",
    "addFirstServiceInstructionInfo": "❌ inquiries.addFirstServiceInstructionInfo",
    "caanotCreateOrder": "❌ inquiries.caanotCreateOrder",
    "executionTime": "❌ inquiries.executionTime",
    "failedToAddProductsToOrder": "❌ inquiries.failedToAddProductsToOrder",
    "globalServicesTooltip": "❌ inquiries.globalServicesTooltip",
    "needExecutionTill": "❌ inquiries.needExecutionTill",
    "noComments": "❌ inquiries.noComments",
    "noDateSelected": "❌ inquiries.noDateSelected",
    "orderAdditionalInfo": "❌ inquiries.orderAdditionalInfo",
    "selectExecutionTime": "❌ inquiries.selectExecutionTime",
    "trackingNumber": "❌ inquiries.trackingNumber",
    "unexpectedErrorOccured": "❌ inquiries.unexpectedErrorOccured"
  },
  "login": {
    "authError": "❌ login.authError",
    "emailPlaceholder": "❌ login.emailPlaceholder",
    "loginInProgress": "❌ login.loginInProgress",
    "loginLabel": "❌ login.loginLabel",
    "password": "❌ login.password",
    "passwordPlaceholder": "❌ login.passwordPlaceholder",
    "register": "❌ login.register",
    "resetPassword": "❌ login.resetPassword"
  },
  "noPermissions": {
    "noPermissionsDescription": "❌ noPermissions.noPermissionsDescription",
    "noPermissionsText": "❌ noPermissions.noPermissionsText",
    "noPermissionsTitle": "❌ noPermissions.noPermissionsTitle"
  },
  "order": {
    "addNewDraft": "❌ order.addNewDraft",
    "addNewFemenine": "❌ order.addNewFemenine",
    "addNewOrder": "❌ order.addNewOrder",
    "addNewShippingAddress": "❌ order.addNewShippingAddress",
    "addedProducts": "❌ order.addedProducts",
    "addressRemoved": "❌ order.addressRemoved",
    "awaitingInvoice": "❌ order.awaitingInvoice",
    "awaitingProductionComplete": "❌ order.awaitingProductionComplete",
    "awaitingSample": "❌ order.awaitingSample",
    "awaitingSampleAcceptance": "❌ order.awaitingSampleAcceptance",
    "beeingCollected": "❌ order.beeingCollected",
    "blockade": "❌ order.blockade",
    "cartonsMissingInfo": "❌ order.cartonsMissingInfo",
    "cartonsNumber": "❌ order.cartonsNumber",
    "checkFormDesc": "❌ order.checkFormDesc",
    "checkFormTitle": "❌ order.checkFormTitle",
    "chooseShippingAddress": "❌ order.chooseShippingAddress",
    "clientContactPerson": "❌ order.clientContactPerson",
    "connectedInvoices": "❌ order.connectedInvoices",
    "currentDiscountOfCustomer": "❌ order.currentDiscountOfCustomer",
    "customerAndName": "❌ order.customerAndName",
    "customerDiscounts": "❌ order.customerDiscounts",
    "dashOrderAwaitingShipping": "❌ order.dashOrderAwaitingShipping",
    "dashReadyForShipping": "❌ order.dashReadyForShipping",
    "dateOfIssue": "❌ order.dateOfIssue",
    "deleted": "❌ order.deleted",
    "delivery": "❌ order.delivery",
    "download": "❌ order.download",
    "downloadPDF": "❌ order.downloadPDF",
    "downloadPDFforMe": "❌ order.downloadPDFforMe",
    "downloadPDFforMyCustomer": "❌ order.downloadPDFforMyCustomer",
    "downloadXls": "❌ order.downloadXls",
    "draftDeleteConfirmTitle": "❌ order.draftDeleteConfirmTitle",
    "draftDeleteErrorText": "❌ order.draftDeleteErrorText",
    "draftDeleteSuccessText": "❌ order.draftDeleteSuccessText",
    "draftDeleteSuccessTitle": "❌ order.draftDeleteSuccessTitle",
    "draftsList": "❌ order.draftsList",
    "duplicateOrder": {
      "questionTextOffer": "❌ order.duplicateOrder.questionTextOffer",
      "questionTextOrder": "❌ order.duplicateOrder.questionTextOrder",
      "questionTitle": "❌ order.duplicateOrder.questionTitle",
      "successTextOffer": "❌ order.duplicateOrder.successTextOffer",
      "successTextOrder": "❌ order.duplicateOrder.successTextOrder",
      "successTitleOffer": "❌ order.duplicateOrder.successTitleOffer",
      "successTitleOrder": "❌ order.duplicateOrder.successTitleOrder"
    },
    "editDraft": "❌ order.editDraft",
    "editDraftErrorText": "❌ order.editDraftErrorText",
    "editDraftSaveSuccessText": "❌ order.editDraftSaveSuccessText",
    "editDraftSuccessTitle": "❌ order.editDraftSuccessTitle",
    "editingOfferFromHPL1": "❌ order.editingOfferFromHPL1",
    "editingOfferFromHPL2": "❌ order.editingOfferFromHPL2",
    "editingOfferFromHPL3": "❌ order.editingOfferFromHPL3",
    "ended": "❌ order.ended",
    "errors": {
      "shipping_price_not_fetched": "❌ order.errors.shipping_price_not_fetched"
    },
    "fileSuffixOfferCustomer": "❌ order.fileSuffixOfferCustomer",
    "fileSuffixOfferMe": "❌ order.fileSuffixOfferMe",
    "files": {
      "addingFile": "❌ order.files.addingFile",
      "deleteFile": "❌ order.files.deleteFile",
      "editFile": "❌ order.files.editFile",
      "editFileText": "❌ order.files.editFileText",
      "editFileTitle": "❌ order.files.editFileTitle",
      "fileEditError": "❌ order.files.fileEditError",
      "noFilesToDisplay": "❌ order.files.noFilesToDisplay",
      "noServiceFilesToDisplay": "❌ order.files.noServiceFilesToDisplay",
      "removeFileDesc": "❌ order.files.removeFileDesc",
      "removeFileTitle": "❌ order.files.removeFileTitle",
      "title": "❌ order.files.title",
      "uploadError": "❌ order.files.uploadError"
    },
    "forAcceptance": "❌ order.forAcceptance",
    "inProduction": "❌ order.inProduction",
    "includedCustomerDiscount": "❌ order.includedCustomerDiscount",
    "includedMarkup": "❌ order.includedMarkup",
    "invoicesIssued": "❌ order.invoicesIssued",
    "lastChange": "❌ order.lastChange",
    "lastItemModified": "❌ order.lastItemModified",
    "lastItemViewed": "❌ order.lastItemViewed",
    "nameCheck": {
      "inProgress": "❌ order.nameCheck.inProgress",
      "inUse": "❌ order.nameCheck.inUse",
      "isAvailable": "❌ order.nameCheck.isAvailable"
    },
    "noAddressFound": "❌ order.noAddressFound",
    "noAddresses": "❌ order.noAddresses",
    "noAddressesForThisClient": "❌ order.noAddressesForThisClient",
    "noContactPeople": "❌ order.noContactPeople",
    "noInvoicesConnectedToOrder": "❌ order.noInvoicesConnectedToOrder",
    "noOffersOrOrdersToDisplay": "❌ order.noOffersOrOrdersToDisplay",
    "noOrderMatchingPhraseFound": "❌ order.noOrderMatchingPhraseFound",
    "noTagsMatchingGivenPhrase": "❌ order.noTagsMatchingGivenPhrase",
    "number": "❌ order.number",
    "numberOfOrderdProducts": "❌ order.numberOfOrderdProducts",
    "offerCurrency": "❌ order.offerCurrency",
    "offerLanguage": "❌ order.offerLanguage",
    "offerPreparedFor": "❌ order.offerPreparedFor",
    "offerSubmissionDate": "❌ order.offerSubmissionDate",
    "offersToCheck": "❌ order.offersToCheck",
    "orderNumber": "❌ order.orderNumber",
    "orderPreparedFor": "❌ order.orderPreparedFor",
    "orderPreview": "❌ order.orderPreview",
    "orders": "❌ order.orders",
    "ordersList": "❌ order.ordersList",
    "ordersXlsFilename": "❌ order.ordersXlsFilename",
    "paymentDate": "❌ order.paymentDate",
    "paymentDeadline": "❌ order.paymentDeadline",
    "pdfDownloadNoticeDesc": "❌ order.pdfDownloadNoticeDesc",
    "pdfDownloadNoticeTitle": "❌ order.pdfDownloadNoticeTitle",
    "pendingPayment": "❌ order.pendingPayment",
    "priceChangePopup": {
      "changeSource": "❌ order.priceChangePopup.changeSource",
      "element": "❌ order.priceChangePopup.element",
      "new": "❌ order.priceChangePopup.new",
      "previous": "❌ order.priceChangePopup.previous",
      "sources": {
        "prices": "❌ order.priceChangePopup.sources.prices",
        "customer_prices": "❌ order.priceChangePopup.sources.customer_prices"
      },
      "subtitle": "❌ order.priceChangePopup.subtitle",
      "title": "❌ order.priceChangePopup.title",
      "type": "❌ order.priceChangePopup.type",
      "types": {
        "globalServiceMultipleFrom": "❌ order.priceChangePopup.types.globalServiceMultipleFrom",
        "globalServicePrice": "❌ order.priceChangePopup.types.globalServicePrice",
        "globalServiceSetupPrice": "❌ order.priceChangePopup.types.globalServiceSetupPrice",
        "product": "❌ order.priceChangePopup.types.product",
        "serviceMultipleFrom": "❌ order.priceChangePopup.types.serviceMultipleFrom",
        "servicePrice": "❌ order.priceChangePopup.types.servicePrice",
        "serviceSetupPrice": "❌ order.priceChangePopup.types.serviceSetupPrice"
      }
    },
    "productMinQty": "❌ order.productMinQty",
    "productsTags": "❌ order.productsTags",
    "readyForShipping": "❌ order.readyForShipping",
    "saveAsOrder": "❌ order.saveAsOrder",
    "saveAsOrderNoticeDesc": "❌ order.saveAsOrderNoticeDesc",
    "saveAsOrderNoticeTitle": "❌ order.saveAsOrderNoticeTitle",
    "saveDraft": "❌ order.saveDraft",
    "see": "❌ order.see",
    "selectOrder": "❌ order.selectOrder",
    "sent": "❌ order.sent",
    "servicesGenitive": "❌ order.servicesGenitive",
    "shippingAddress": "❌ order.shippingAddress",
    "showAddress": "❌ order.showAddress",
    "showContact": "❌ order.showContact",
    "summary": "❌ order.summary",
    "toCheckInWarehouse": "❌ order.toCheckInWarehouse",
    "toCollect": "❌ order.toCollect",
    "toDelete": "❌ order.toDelete",
    "totalCost": "❌ order.totalCost",
    "totalDeliveryCostNet": "❌ order.totalDeliveryCostNet",
    "useCustomerDiscounts": "❌ order.useCustomerDiscounts",
    "usePartnerPricing": "❌ order.usePartnerPricing",
    "valueForPartnerCustomer": "❌ order.valueForPartnerCustomer",
    "waitingForShipping": "❌ order.waitingForShipping",
    "waitingPurchaseProducts": "❌ order.waitingPurchaseProducts",
    "whoOrders": "❌ order.whoOrders",
    "whoOrdersMe": "❌ order.whoOrdersMe",
    "whoOrdersMyCustomer": "❌ order.whoOrdersMyCustomer",
    "withDeadlineApproaching": "❌ order.withDeadlineApproaching",
    "yesSave": "❌ order.yesSave",
    "yourDiscounts": "❌ order.yourDiscounts",
    "yourPrice": "❌ order.yourPrice"
  },
  "price": {
    "addNewPrice": "❌ price.addNewPrice",
    "addNewProductPrice": "❌ price.addNewProductPrice",
    "addNewServicePrice": "❌ price.addNewServicePrice",
    "addNewSetupPrice": "❌ price.addNewSetupPrice",
    "addPrice": "❌ price.addPrice",
    "addPriceErrorText": "❌ price.addPriceErrorText",
    "addPriceSuccessText": "❌ price.addPriceSuccessText",
    "addPriceSuccessTitle": "❌ price.addPriceSuccessTitle",
    "bruttonPrice": "❌ price.bruttonPrice",
    "chosenPriceIsSetupPrice": "❌ price.chosenPriceIsSetupPrice",
    "deletePriceConfirmTitle": "❌ price.deletePriceConfirmTitle",
    "deletePriceErrorText": "❌ price.deletePriceErrorText",
    "deletePriceSuccessText": "❌ price.deletePriceSuccessText",
    "deletePriceSuccessTitle": "❌ price.deletePriceSuccessTitle",
    "differentPriceMultipleFromInfo": "❌ price.differentPriceMultipleFromInfo",
    "editPrice": "❌ price.editPrice",
    "export": "❌ price.export",
    "exportPrices": "❌ price.exportPrices",
    "exportSuccessfull": "❌ price.exportSuccessfull",
    "exportSuccessfullDesc": "❌ price.exportSuccessfullDesc",
    "importPrices": "❌ price.importPrices",
    "importSuccessfull": "❌ price.importSuccessfull",
    "importSuccessfullDesc": "❌ price.importSuccessfullDesc",
    "includeSetupPrices": "❌ price.includeSetupPrices",
    "isSale": "❌ price.isSale",
    "noPricesFoundForServiceGroup": "❌ price.noPricesFoundForServiceGroup",
    "noPricesToDisplay": "❌ price.noPricesToDisplay",
    "onlyPriceUpdate": "❌ price.onlyPriceUpdate",
    "pln": "❌ price.pln",
    "plnBrutto": "❌ price.plnBrutto",
    "plnNet": "❌ price.plnNet",
    "plnVat": "❌ price.plnVat",
    "price": "❌ price.price",
    "priceFlat": "❌ price.priceFlat",
    "priceBox": "❌ price.priceBox",
    "price25pcs": "❌ price.price25pcs",
    "priceFirstBox": "❌ price.priceFirstBox",
    "priceSecondBox": "❌ price.priceSecondBox",
    "priceNextBox": "❌ price.priceNextBox",
    "priceBeforeDicount": "❌ price.priceBeforeDicount",
    "priceEdit": "❌ price.priceEdit",
    "priceFrom": "❌ price.priceFrom",
    "priceImportFrom": "❌ price.priceImportFrom",
    "priceNet": "❌ price.priceNet",
    "pricePerItem": "❌ price.pricePerItem",
    "pricePerItemFrom": "❌ price.pricePerItemFrom",
    "pricePerItemShort": "❌ price.pricePerItemShort",
    "prices": "❌ price.prices",
    "priceTo": "❌ price.priceTo",
    "pricesLists": "❌ price.pricesLists",
    "pricesListsLowCase": "❌ price.pricesListsLowCase",
    "productGenitive": "❌ price.productGenitive",
    "productsPricesList": "❌ price.productsPricesList",
    "quantityFrom": "❌ price.quantityFrom",
    "quantityTo": "❌ price.quantityTo",
    "removeAndReplacePrices": "❌ price.removeAndReplacePrices",
    "savePriceErrorText": "❌ price.savePriceErrorText",
    "savePriceSuccessText": "❌ price.savePriceSuccessText",
    "savePriceSuccessTitle": "❌ price.savePriceSuccessTitle",
    "seePricelist": "❌ price.seePricelist",
    "serviceGenitive": "❌ price.serviceGenitive",
    "servicesPriceList": "❌ price.servicesPriceList",
    "servicesPricesList": "❌ price.servicesPricesList",
    "setup": "❌ price.setup",
    "setupPricesList": "❌ price.setupPricesList",
    "supplierPricesFileNamePrefix": "❌ price.supplierPricesFileNamePrefix",
    "unitPricesIn": "❌ price.unitPricesIn",
    "vat": "❌ price.vat",
    "vatRate": "❌ price.vatRate",
    "xlsxFileWithPrices": "❌ price.xlsxFileWithPrices"
  },
  "product": {
    "addGlobalService": "❌ product.addGlobalService",
    "addGlobalServicesPackage": "❌ product.addGlobalServicesPackage",
    "addProduct": "❌ product.addProduct",
    "breakProductsIntoSeparateOffers": "❌ product.breakProductsIntoSeparateOffers",
    "checkAvailability": "❌ product.checkAvailability",
    "enterAdditionalProductDescriptionOptional": "❌ product.enterAdditionalProductDescriptionOptional",
    "enterProductNameOrCode": "❌ product.enterProductNameOrCode",
    "globalServices": "❌ product.globalServices",
    "noProductsMatchingGivenPhrase": "❌ product.noProductsMatchingGivenPhrase",
    "notIncludedInDiscounts": "❌ product.notIncludedInDiscounts",
    "product": "❌ product.product",
    "productCode": "❌ product.productCode",
    "productName": "❌ product.productName",
    "products": "❌ product.products",
    "productsCodes": "❌ product.productsCodes",
    "selectProduct": "❌ product.selectProduct",
    "totalBeforeDiscount": "❌ product.totalBeforeDiscount",
    "totalMarkup": "❌ product.totalMarkup",
    "totalProductsCostNet": "❌ product.totalProductsCostNet",
    "totalServicesCostNet": "❌ product.totalServicesCostNet",
    "useCustomPartnerPrice": "❌ product.useCustomPartnerPrice",
    "useDefaultPartnerPrice": "❌ product.useDefaultPartnerPrice"
  },
  "purchase": {
    "addOrderErrorText": "❌ purchase.addOrderErrorText",
    "editOrderSuccessTitle": "❌ purchase.editOrderSuccessTitle",
    "fileDeletedDesc": "❌ purchase.fileDeletedDesc",
    "fileDeletedTitle": "❌ purchase.fileDeletedTitle",
    "numberOfPiecesNeeded": "❌ purchase.numberOfPiecesNeeded",
    "removeFileInProgress": "❌ purchase.removeFileInProgress",
    "yourOrderSaveSuccessText": "❌ purchase.yourOrderSaveSuccessText"
  },
  "register": {
    "customerTaxNumber": "❌ register.customerTaxNumber",
    "login": "❌ register.login",
    "password": "❌ register.password",
    "passwordConfirmation": "❌ register.passwordConfirmation",
    "passwordReset": {
      "error": "❌ register.passwordReset.error",
      "resetLabel": "❌ register.passwordReset.resetLabel",
      "resetInProgress": "❌ register.passwordReset.resetInProgress",
      "success": "❌ register.passwordReset.success",
      "title": "❌ register.passwordReset.title"
    },
    "passwordResetRequest": {
      "error": "❌ register.passwordResetRequest.error",
      "resetInProgress": "❌ register.passwordResetRequest.resetInProgress",
      "resetLabel": "❌ register.passwordResetRequest.resetLabel",
      "success": "❌ register.passwordResetRequest.success",
      "title": "❌ register.passwordResetRequest.title"
    },
    "registerError": "❌ register.registerError",
    "registerInProgress": "❌ register.registerInProgress",
    "registerLabel": "❌ register.registerLabel",
    "registerSuccess": "❌ register.registerSuccess",
    "title": "❌ register.title"
  },
  "service": {
    "addService": "❌ service.addService",
    "addServicesPackage": "❌ service.addServicesPackage",
    "addServicesPackageBtn": "❌ service.addServicesPackageBtn",
    "chooseEmbroideryPosition": "❌ service.chooseEmbroideryPosition",
    "chooseEmbroideryType": "❌ service.chooseEmbroideryType",
    "chooseService": "❌ service.chooseService",
    "chooseServiceGroup": "❌ service.chooseServiceGroup",
    "commonServices": "❌ service.commonServices",
    "complexity": "❌ service.complexity",
    "descriptionFoCustomer": "❌ service.descriptionFoCustomer",
    "detailsOfServiceInOrder": "❌ service.detailsOfServiceInOrder",
    "downloadLogo": "❌ service.downloadLogo",
    "dstNumber": "❌ service.dstNumber",
    "embroidery": {
      "colors": "❌ service.embroidery.colors",
      "height": "❌ service.embroidery.height",
      "position": "❌ service.embroidery.position",
      "size": "❌ service.embroidery.size",
      "type": "❌ service.embroidery.type",
      "width": "❌ service.embroidery.width"
    },
    "enterServiceNameOrCode": "❌ service.enterServiceNameOrCode",
    "files": {
      "title": "❌ service.files.title"
    },
    "findService": "❌ service.findService",
    "noServiceGroupsMatchingPhrase": "❌ service.noServiceGroupsMatchingPhrase",
    "noServicesMatchingPhrase": "❌ service.noServicesMatchingPhrase",
    "productionCompleteDate": "❌ service.productionCompleteDate",
    "sample": {
      "sampleAcceptDate": "❌ service.sample.sampleAcceptDate",
      "sampleDate": "❌ service.sample.sampleDate",
      "samplePhotosDateCreated": "❌ service.sample.samplePhotosDateCreated",
      "samplePhotosDownload": "❌ service.sample.samplePhotosDownload",
      "samplePhotosDownloadAll": "❌ service.sample.samplePhotosDownloadAll",
      "samplePhotosSeePreview": "❌ service.sample.samplePhotosSeePreview",
      "samplePhotosTitle": "❌ service.sample.samplePhotosTitle",
      "sampleReceiveDate": "❌ service.sample.sampleReceiveDate"
    },
    "sampleFiles": {
      "title": "❌ service.sampleFiles.title"
    },
    "samples": {
      "noSamples": "❌ service.samples.noSamples",
      "rejectReason": "❌ service.samples.rejectReason",
      "sample": "❌ service.samples.sample",
      "saveBeforeAddingFiles": "❌ service.samples.saveBeforeAddingFiles",
      "statuses": {
        "accepted": "❌ service.samples.statuses.accepted",
        "rejected": "❌ service.samples.statuses.rejected"
      },
      "title": "❌ service.samples.title"
    },
    "selectFileWithLogo": "❌ service.selectFileWithLogo",
    "selectService": "❌ service.selectService",
    "selectedServiceName": "❌ service.selectedServiceName",
    "service": "❌ service.service",
    "serviceCode": "❌ service.serviceCode",
    "serviceGroup": "❌ service.serviceGroup",
    "serviceName": "❌ service.serviceName",
    "serviceNotFound": "❌ service.serviceNotFound",
    "serviceNotFoundDesc": "❌ service.serviceNotFoundDesc",
    "servicesPackage": {
      "dates": {
        "date": "❌ service.servicesPackage.dates.date",
        "types": {
          "obtaining_at": "❌ service.servicesPackage.dates.types.obtaining_at",
          "accepted_at": "❌ service.servicesPackage.dates.types.accepted_at",
          "sample_hpl_accepted_at": "❌ service.servicesPackage.dates.types.sample_hpl_accepted_at"
        }
      }
    },
    "servicesPackageHideContents": "❌ service.servicesPackageHideContents",
    "servicesPackageInvalidConfig": {
      "noMatchingService": "❌ service.servicesPackageInvalidConfig.noMatchingService",
      "wrongDimensions": "❌ service.servicesPackageInvalidConfig.wrongDimensions"
    },
    "servicesPackageModify": "❌ service.servicesPackageModify",
    "servicesPackageVariant": "❌ service.servicesPackageVariant",
    "servicesPackageName": "❌ service.servicesPackageName",
    "servicesPackagePopup": {
      "addServicesPackage": "❌ service.servicesPackagePopup.addServicesPackage",
      "includedServices": "❌ service.servicesPackagePopup.includedServices",
      "noServicesIncluded": "❌ service.servicesPackagePopup.noServicesIncluded",
      "noServicesPackagesMatchingGivenPhrase": "❌ service.servicesPackagePopup.noServicesPackagesMatchingGivenPhrase",
      "selectServicesPackage": "❌ service.servicesPackagePopup.selectServicesPackage",
      "title": "❌ service.servicesPackagePopup.title"
    },
    "servicesPackageShowContents": "❌ service.servicesPackageShowContents",
    "setupPrice": "❌ service.setupPrice",
    "stitchNumber": "❌ service.stitchNumber",
    "strandColors": "❌ service.strandColors",
    "wrongDimensions": "❌ service.wrongDimensions",
    "wrongDimensionsDesc": "❌ service.wrongDimensionsDesc"
  },
  "settings": {
    "country": {
      "country": "❌ settings.country.country",
      "countryCode": "❌ settings.country.countryCode",
      "selectCountry": "❌ settings.country.selectCountry"
    },
    "currency": {
      "chooseCurrency": "❌ settings.currency.chooseCurrency",
      "currency": "❌ settings.currency.currency",
      "noCurrenciesAvailable": "❌ settings.currency.noCurrenciesAvailable"
    },
    "language": {
      "chooseLanguage": "❌ settings.language.chooseLanguage",
      "noLanguagesAvailable": "❌ settings.language.noLanguagesAvailable"
    },
    "transaltion": {
      "addTranslation": "❌ settings.transaltion.addTranslation",
      "addTranslationErrorText": "❌ settings.transaltion.addTranslationErrorText",
      "addTranslationSuccessText": "❌ settings.transaltion.addTranslationSuccessText",
      "addTranslationSuccessTitle": "❌ settings.transaltion.addTranslationSuccessTitle",
      "deleteTranslationConfirmTitle": "❌ settings.transaltion.deleteTranslationConfirmTitle",
      "deleteTranslationErrorText": "❌ settings.transaltion.deleteTranslationErrorText",
      "deleteTranslationSuccessText": "❌ settings.transaltion.deleteTranslationSuccessText",
      "deleteTranslationSuccessTitle": "❌ settings.transaltion.deleteTranslationSuccessTitle",
      "editTranslation": "❌ settings.transaltion.editTranslation",
      "translationEditErrorText": "❌ settings.transaltion.translationEditErrorText",
      "translationEditSuccessText": "❌ settings.transaltion.translationEditSuccessText",
      "translationEditSuccessTitle": "❌ settings.transaltion.translationEditSuccessTitle",
      "translations": "❌ settings.transaltion.translations"
    }
  },
  "settlements": {
    "amount": "❌ settlements.amount",
    "deadlines": "❌ settlements.deadlines",
    "invoiceList": "❌ settlements.invoiceList",
    "issued": "❌ settlements.issued",
    "noSettlementsToDisplay": "❌ settlements.noSettlementsToDisplay",
    "paymentDueDate": "❌ settlements.paymentDueDate",
    "settle": "❌ settlements.settle",
    "settled": "❌ settlements.settled",
    "settlement": "❌ settlements.settlement",
    "settlements": "❌ settlements.settlements",
    "type": "❌ settlements.type"
  },
  "shippers": {
    "chooseShipper": "❌ shippers.chooseShipper",
    "noShippersAvailable": "❌ shippers.noShippersAvailable"
  },
  "status": {
    "status": "❌ status.status",
    "statusQuestionMark": "❌ status.statusQuestionMark"
  },
  "translation": {
    "editTranslation": "❌ translation.editTranslation",
    "languageLocative": "❌ translation.languageLocative",
    "languagesLocative": "❌ translation.languagesLocative",
    "missingTranslationsIn": "❌ translation.missingTranslationsIn",
    "noTranslationsToDisplay": "❌ translation.noTranslationsToDisplay",
    "systemName": "❌ translation.systemName",
    "translated": "❌ translation.translated",
    "translationEditErrorText": "❌ translation.translationEditErrorText",
    "translationEditSuccessText": "❌ translation.translationEditSuccessText",
    "translationEditSuccessTitle": "❌ translation.translationEditSuccessTitle",
    "translationStatus": "❌ translation.translationStatus",
    "translations": "❌ translation.translations",
    "translationsTitle": "❌ translation.translationsTitle",
    "valueInPolish": "❌ translation.valueInPolish"
  },
  "ui": {
    "actionFailedTryAgain": "❌ ui.actionFailedTryAgain",
    "actions": "❌ ui.actions",
    "add": "❌ ui.add",
    "addDescription": "❌ ui.addDescription",
    "addNew": "❌ ui.addNew",
    "addToCart": "❌ ui.addToCart",
    "address": "❌ ui.address",
    "allFieldsAreRequired": "❌ ui.allFieldsAreRequired",
    "amount": "❌ ui.amount",
    "availability": "❌ ui.availability",
    "back": "❌ ui.back",
    "backToList": "❌ ui.backToList",
    "cancel": "❌ ui.cancel",
    "cart": "❌ ui.cart",
    "cartIsEmpty": "❌ ui.cartIsEmpty",
    "chooseDate": "❌ ui.chooseDate",
    "close": "❌ ui.close",
    "companyName": "❌ ui.companyName",
    "contactPerson": "❌ ui.contactPerson",
    "createOrderFromCart": "❌ ui.createOrderFromCart",
    "dataLoading": "❌ ui.dataLoading",
    "dataLoadingFailed": "❌ ui.dataLoadingFailed",
    "daysOfWeek": {
      "fri": "❌ ui.daysOfWeek.fri",
      "mon": "❌ ui.daysOfWeek.mon",
      "sat": "❌ ui.daysOfWeek.sat",
      "sun": "❌ ui.daysOfWeek.sun",
      "thur": "❌ ui.daysOfWeek.thur",
      "tue": "❌ ui.daysOfWeek.tue",
      "wed": "❌ ui.daysOfWeek.wed"
    },
    "deadlinePreferred": "❌ ui.deadlinePreferred",
    "delete": "❌ ui.delete",
    "deleteConfirmText": "❌ ui.deleteConfirmText",
    "downloadInProgress": "❌ ui.downloadInProgress",
    "duplicate": "❌ ui.duplicate",
    "eMailCap": "❌ ui.eMailCap",
    "eMailShort": "❌ ui.eMailShort",
    "edit": "❌ ui.edit",
    "emailAddress": "❌ ui.emailAddress",
    "errorOccured": "❌ ui.errorOccured",
    "errorOccuredDuringDownload": "❌ ui.errorOccuredDuringDownload",
    "filtersSearch": "❌ ui.filtersSearch",
    "generalInfo": "❌ ui.generalInfo",
    "importErrorTitle": "❌ ui.importErrorTitle",
    "importFile": "❌ ui.importFile",
    "importType": "❌ ui.importType",
    "inCart": "❌ ui.inCart",
    "invoiceNumber": "❌ ui.invoiceNumber",
    "isSettled": "❌ ui.isSettled",
    "lack": "❌ ui.lack",
    "language": "❌ ui.language",
    "leadingPerson": "❌ ui.leadingPerson",
    "loadError": "❌ ui.loadError",
    "markupProducts": "❌ ui.markupProducts",
    "markupServices": "❌ ui.markupServices",
    "markupSetupServices": "❌ ui.markupSetupServices",
    "markupShipping": "❌ ui.markupShipping",
    "monthNames": {
      "apr": "❌ ui.monthNames.apr",
      "aug": "❌ ui.monthNames.aug",
      "dec": "❌ ui.monthNames.dec",
      "feb": "❌ ui.monthNames.feb",
      "jan": "❌ ui.monthNames.jan",
      "jul": "❌ ui.monthNames.jul",
      "jun": "❌ ui.monthNames.jun",
      "mar": "❌ ui.monthNames.mar",
      "may": "❌ ui.monthNames.may",
      "nov": "❌ ui.monthNames.nov",
      "oct": "❌ ui.monthNames.oct",
      "sep": "❌ ui.monthNames.sep"
    },
    "myOrders": "❌ ui.myOrders",
    "name": "❌ ui.name",
    "nameAndSurename": "❌ ui.nameAndSurename",
    "no": "❌ ui.no",
    "noAvailabilityData": "❌ ui.noAvailabilityData",
    "notSettled": "❌ ui.notSettled",
    "ok": "❌ ui.ok",
    "okUnderstand": "❌ ui.okUnderstand",
    "order": "❌ ui.order",
    "orderName": "❌ ui.orderName",
    "pagination": {
      "itemsAmount": "❌ ui.pagination.itemsAmount"
    },
    "partnerDiscountProducts": "❌ ui.partnerDiscountProducts",
    "partnerDiscountServices": "❌ ui.partnerDiscountServices",
    "partnerDiscountShipping": "❌ ui.partnerDiscountShipping",
    "phoneShort": "❌ ui.phoneShort",
    "pieces": "❌ ui.pieces",
    "piecesAbbr": "❌ ui.piecesAbbr",
    "piecesAmount": "❌ ui.piecesAmount",
    "productsGenitive": "❌ ui.productsGenitive",
    "refNumber": "❌ ui.refNumber",
    "refreshPage": "❌ ui.refreshPage",
    "repeatPassword": "❌ ui.repeatPassword",
    "resetFilters": "❌ ui.resetFilters",
    "saveChanges": "❌ ui.saveChanges",
    "search": "❌ ui.search",
    "searchFrom": "❌ ui.searchFrom",
    "searchTo": "❌ ui.searchTo",
    "searching": "❌ ui.searching",
    "selectContactPerson": "❌ ui.selectContactPerson",
    "selectFile": "❌ ui.selectFile",
    "selectLeadingPerson": "❌ ui.selectLeadingPerson",
    "selectedPersonNotFound": "❌ ui.selectedPersonNotFound",
    "settled": "❌ ui.settled",
    "shipper": "❌ ui.shipper",
    "supplier": "❌ ui.supplier",
    "toTryAgain": "❌ ui.toTryAgain",
    "tryAgain": "❌ ui.tryAgain",
    "value": "❌ ui.value",
    "viewInNewTab": "❌ ui.viewInNewTab",
    "yes": "❌ ui.yes",
    "yesRemove": "❌ ui.yesRemove"
  },
  "users": {
    "accountActive": "❌ users.accountActive",
    "accountInactive": "❌ users.accountInactive",
    "active": "❌ users.active",
    "addUser": "❌ users.addUser",
    "addUserErrorText": "❌ users.addUserErrorText",
    "addUserSuccessText": "❌ users.addUserSuccessText",
    "addUserSuccessTitle": "❌ users.addUserSuccessTitle",
    "addingNewUser": "❌ users.addingNewUser",
    "customer": "❌ users.customer",
    "deleteConfirmTitle": "❌ users.deleteConfirmTitle",
    "deleteErrorText": "❌ users.deleteErrorText",
    "deleteSuccessText": "❌ users.deleteSuccessText",
    "deleteSuccessTitle": "❌ users.deleteSuccessTitle",
    "editUser": "❌ users.editUser",
    "editUserErrorText": "❌ users.editUserErrorText",
    "editUserSuccessText": "❌ users.editUserSuccessText",
    "editUserSuccessTitle": "❌ users.editUserSuccessTitle",
    "inactive": "❌ users.inactive",
    "isAccountActive": "❌ users.isAccountActive",
    "loggedInAs": "❌ users.loggedInAs",
    "noUsersMatchingPhrase": "❌ users.noUsersMatchingPhrase",
    "noUsersToDisplay": "❌ users.noUsersToDisplay",
    "selectWorker": "❌ users.selectWorker",
    "usersLabel": "❌ users.usersLabel",
    "usersList": "❌ users.usersList",
    "usersSearchPlaceholder": "❌ users.usersSearchPlaceholder"
  },
  "validation": {
    "fieldCanContainAtLeast1Char": "❌ validation.fieldCanContainAtLeast1Char",
    "fieldCanContainAtLeast24Chars": "❌ validation.fieldCanContainAtLeast24Chars",
    "fieldCanContainAtLeastNChars": "❌ validation.fieldCanContainAtLeastNChars",
    "fieldCanContainAtMax1Char": "❌ validation.fieldCanContainAtMax1Char",
    "fieldCanContainAtMax24Chars": "❌ validation.fieldCanContainAtMax24Chars",
    "fieldCanContainAtMaxNChars": "❌ validation.fieldCanContainAtMaxNChars",
    "onlyBigLetters": "❌ validation.onlyBigLetters",
    "onlyLettersAndDashes": "❌ validation.onlyLettersAndDashes",
    "onlyLettersAndNumbers": "❌ validation.onlyLettersAndNumbers",
    "onlyNumbers": "❌ validation.onlyNumbers",
    "onlyIntegerNumbers": "❌ validation.onlyIntegerNumbers",
    "passwordsAreNotIdentical": "❌ validation.passwordsAreNotIdentical",
    "required": "❌ validation.required",
    "validDoubleNumericRequired": "❌ validation.validDoubleNumericRequired",
    "validEmailRequired": "❌ validation.validEmailRequired",
    "validUrlRequired": "❌ validation.validUrlRequired",
    "valueCannotBeGreaterThan": "❌ validation.valueCannotBeGreaterThan",
    "valueCannotBeLessThan": "❌ validation.valueCannotBeLessThan",
    "valueMustContainOrderID": "❌ validation.valueMustContainOrderID",
    "youMustSelectValue": "❌ validation.youMustSelectValue"
  },
  "welcome": {
    "baseballCaps": "❌ welcome.baseballCaps",
    "capVizors": "❌ welcome.capVizors",
    "choose": "❌ welcome.choose",
    "clear": "❌ welcome.clear",
    "clientPanel": "❌ welcome.clientPanel",
    "companyName": "❌ welcome.companyName",
    "filter": "❌ welcome.filter",
    "filterAvailability": "❌ welcome.filterAvailability",
    "filterByNameOrCode": "❌ welcome.filterByNameOrCode",
    "filterByPrice": "❌ welcome.filterByPrice",
    "hats": "❌ welcome.hats",
    "noProductsInSearchCriteria": "❌ welcome.noProductsInSearchCriteria",
    "orderInfo": "❌ welcome.orderInfo",
    "productBrowserInfo": "❌ welcome.productBrowserInfo",
    "requireAll": "❌ welcome.requireAll",
    "searchProducts": "❌ welcome.searchProducts",
    "setp": "❌ welcome.setp",
    "stepFiveContent": "❌ welcome.stepFiveContent",
    "stepFourContent": "❌ welcome.stepFourContent",
    "stepOneContent": "❌ welcome.stepOneContent",
    "stepThreeContent": "❌ welcome.stepThreeContent",
    "stepTwoContent": "❌ welcome.stepTwoContent",
    "wantToCheckOurProducts": "❌ welcome.wantToCheckOurProducts",
    "welcomeToClientPanel": "❌ welcome.welcomeToClientPanel",
    "winterHats": "❌ welcome.winterHats"
  }
};
